(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-optin"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('.tso-optin');
  if (!root) return;

  const cards = {
    loading: root.querySelector('[data-state="loading"]'),
    done: root.querySelector('[data-state="done"]'),
    manual: root.querySelector('[data-state="manual"]'),
  };

  const show = (name) => {
    Object.entries(cards).forEach(([key, el]) => {
      if (el) el.hidden = key !== name;
    });
  };

  // Kopiera koden-knappen i bekräftelsekortet. Clipboard API kräver säker
  // kontext (https), vilket butiken är; execCommand-vägen finns kvar som
  // fallback för äldre webbläsare. Feedback: ikonen byts till en bock och
  // noten under koden säger "Copied!" i två sekunder.
  const copyBtn = root.querySelector('[data-copy-code]');
  if (copyBtn) {
    const iconCopy = copyBtn.querySelector('[data-icon="copy"]');
    const iconCheck = copyBtn.querySelector('[data-icon="check"]');
    const note = root.querySelector('[data-copy-note]');
    const noteText = note ? note.textContent : '';
    let resetTimer = null;

    const legacyCopy = (text) => {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      if (!ok) throw new Error('execCommand copy failed');
    };

    copyBtn.addEventListener('click', async () => {
      const code = copyBtn.dataset.copyCode;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
        } else {
          legacyCopy(code);
        }
      } catch (err) {
        try { legacyCopy(code); } catch (err2) { return; }
      }
      copyBtn.classList.add('is-copied');
      // setAttribute, inte .hidden - egenskapen finns inte pa SVGElement.
      if (iconCopy) iconCopy.setAttribute('hidden', '');
      if (iconCheck) iconCheck.removeAttribute('hidden');
      if (note) note.textContent = 'Copied! Paste it at checkout.';
      clearTimeout(resetTimer);
      resetTimer = setTimeout(() => {
        copyBtn.classList.remove('is-copied');
        if (iconCopy) iconCopy.removeAttribute('hidden');
        if (iconCheck) iconCheck.setAttribute('hidden', '');
        if (note) note.textContent = noteText;
      }, 2000);
    });
  }


  const params = new URLSearchParams(window.location.search);

  // Adressen läses ur den råa query-strängen, inte via URLSearchParams.
  // URLSearchParams tolkar '+' som mellanslag, vilket sabbar adresser av typen
  // marcus+snus@example.com. En e-postadress kan aldrig innehålla mellanslag,
  // så varje '+' i värdet är ett riktigt plustecken. Det gör sidan oberoende av
  // om mejlet hann URL-koda adressen eller inte.
  const readEmail = () => {
    const pair = window.location.search
      .slice(1)
      .split('&')
      .map((part) => part.split('='))
      .find(([key]) => decodeURIComponent(key || '') === 'email');
    if (!pair) return '';
    try {
      return decodeURIComponent((pair[1] || '').replace(/\+/g, '%2B')).trim();
    } catch (err) {
      return '';
    }
  };

  const email = readEmail();
  const firstName = (params.get('fn') || '').trim();

  // Grov men tillräcklig kontroll — Klaviyo validerar på riktigt i sin ände.
  const looksLikeEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);

  if (!looksLikeEmail) {
    const field = document.getElementById('tso-optin-email');
    if (email && field) field.value = email;
    show('manual');
    return;
  }

  const subscribe = async () => {
    const companyId = root.dataset.company;
    const listId = root.dataset.list;
    const revision = root.dataset.revision;

    const profileAttributes = {
      email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
    };
    if (firstName) profileAttributes.first_name = firstName;

    const body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter opt-in email',
          profile: { data: { type: 'profile', attributes: profileAttributes } },
        },
        relationships: { list: { data: { type: 'list', id: listId } } },
      },
    };

    const res = await fetch(
      `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision,
        },
        body: JSON.stringify(body),
      }
    );

    // Endpointen svarar 202 Accepted när prenumerationen är köad.
    if (!res.ok) throw new Error(`Klaviyo responded ${res.status}`);
  };

  const run = async () => {
    try {
      await subscribe();
      const slot = cards.done && cards.done.querySelector('[data-slot="email"]');
      if (slot) slot.textContent = email;
      show('done');
    } catch (err) {
      console.error('[tso-optin]', err);
      const field = document.getElementById('tso-optin-email');
      if (field) field.value = email;
      const lead = cards.manual && cards.manual.querySelector('[data-slot="manual-lead"]');
      if (lead) {
        lead.textContent =
          'Something went wrong on our end. Confirm your address below and we’ll get you on the list.';
      }
      show('manual');
    }
  };

  // Vänta tills fliken faktiskt är synlig. En prerender eller en flik som
  // aldrig öppnas ska inte prenumerera någon. Fördröjningen efteråt filtrerar
  // bort de enklaste länkskannrarna.
  const start = () => setTimeout(run, 400);

  if (document.visibilityState === 'visible') {
    start();
  } else {
    document.addEventListener('visibilitychange', function onVisible() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', onVisible);
      start();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
